/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import * as React from "react";
import {FONTS} from "@res/fonts";
import {
    EventuallyStateStatus,
    EventuallyUpsertStatus,
    GoalsConfigModule,
    OnCareConfigEntryUpdated,
    OnCareConfigJobUpdate,
    OnCareConfigQueryReturned,
    OnCareConfigRemotelyChanged,
    OnCareConfigUpsertEventually
} from "@modules/GoalsConfigModule";
import {CareFieldDef, CareFieldVal} from "@app/app-shared/care_config";
import {DB_Patient} from "@app/app-shared/patient";
import {ConfigGeneral} from "./ConfigGeneral";
import {VGap} from "../widget/VGap";
import {Spacing} from "@styles/styles";
import {UnitCareGoal} from "@app/app-shared/api";
import {PatientsContext} from "../ui/patients/PatientsContext";

type ConfigGeneralWrapperProps = {
    patient: DB_Patient
    title: string
    fieldDefs: CareFieldDef[]
    showActions: boolean
}

type ConfigGeneralWrapperState = {
    // dbConfigs?: PartialProperties<DB_PatientConfig, keyof DB_Object>[]
}

export class ConfigGeneralWrapper
    extends BaseComponent<ConfigGeneralWrapperProps, ConfigGeneralWrapperState>
    implements OnCareConfigQueryReturned, OnCareConfigEntryUpdated, OnCareConfigRemotelyChanged, OnCareConfigUpsertEventually, OnCareConfigJobUpdate {
    __onCareConfigJobUpdate = () => this.forceUpdate();

    state: ConfigGeneralWrapperState = {};

    __onCareConfigUpsertEventually(p: string, latest: boolean, error?: boolean) {
        this.forceUpdate();
    }

    __onCareConfigQueryReturned() {
        this.forceUpdate();
    }

    __onCareConfigRemotelyChanged = (goal?: UnitCareGoal) => {
        // TODO: handle delete
        if (!goal || this.props.patient._id !== goal.unitId)
            return;

        this.forceUpdate();
    };

    __onCareConfigEntryUpdated(created: boolean, success: boolean) {
        this.forceUpdate();
    }

    render() {
        const status = this.deduceStatus();
        const localConfigsPatient = GoalsConfigModule.getLocalConfigsPatient(this.props.patient.unitId);

        return <div className={`ll_v_s`} style={{paddingBottom: 20, position: "relative"}}>
            <div className={"ll_h_c"} style={{justifyContent: "space-between", height: "1.2em"}}>
                {FONTS.reg_18(this.props.title)}
            </div>
            <VGap v={Spacing.m}/>
            <PatientsContext.Consumer>
                {({demo}) => {
                    return <ConfigGeneral
                        configs={localConfigsPatient}
                        onCareConfigUpdate={(key: string, val: CareFieldVal) => GoalsConfigModule.onConfigUpdate(key, val, this.props.patient.unitId, demo)}
                        status={status}
                        fieldDefs={this.props.fieldDefs}
                        patientId={this.props.patient._id}
                        showActions={this.props.showActions}
                    />
                }}
            </PatientsContext.Consumer>

        </div>;
    }

    private deduceStatus = () => {
        const jobs = GoalsConfigModule.getJobsByPatient(this.props.patient.unitId);
        if (jobs.length === 0)
            return EventuallyStateStatus.Synced;

        if (jobs.find(j => j._status === EventuallyUpsertStatus.Error))
            return EventuallyStateStatus.Error;

        return EventuallyStateStatus.Saving;
    };
}
